import { QuerySwitch } from 'components/QuerySwitch';
import {
  FetchDepartmentsDataContext,
  FetchDepartmentsDataProvider,
} from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/contexts/FetchDepartments.data.context';
import { PositionsSettingsRedirectPageComponent } from 'pages/Settings/pages/Positions/PositionsSettingsRedirectPageComponent';

export const PositionsSettingsRedirectPage = () => (
  <FetchDepartmentsDataProvider>
    <QuerySwitch
      component={PositionsSettingsRedirectPageComponent}
      context={FetchDepartmentsDataContext}
    />
  </FetchDepartmentsDataProvider>
);
